var _path, _path2, _circle, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMintTimeline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1874,
    height: 774,
    viewBox: "0 0 1874 774",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M930 386H-6",
    stroke: "white",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1530 386L930 386",
    stroke: "url(#paint0_linear_2359_3082)",
    strokeWidth: 5,
    strokeDasharray: "30 30"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 930.643,
    cy: 385.973,
    r: 15,
    transform: "rotate(-16.5 930.643 385.973)",
    fill: "#FF2784"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2359_3082",
    x1: 963.511,
    y1: 386,
    x2: 1550.74,
    y2: 386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMintTimeline);
export default __webpack_public_path__ + "static/media/mint-timeline.d4436c75a1a42e5b5f94e6be9ce2eefa.svg";
export { ForwardRef as ReactComponent };